// removed by extract-text-webpack-plugin
module.exports = {"loading":"root-module__loading___KZAq1","spinner":"root-module__spinner___TqnLl","root":"root-module__root___mK1MC","smuQaoEmbed":"root-module__smuQaoEmbed___1CAz1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/root/root.module.scss
// module id = 913
// module chunks = 0 1